import { render } from "./MeldingDetailView.vue?vue&type=template&id=efbed78a&scoped=true"
import script from "./MeldingDetailView.vue?vue&type=script&lang=js"
export * from "./MeldingDetailView.vue?vue&type=script&lang=js"

import "./MeldingDetailView.vue?vue&type=style&index=0&id=efbed78a&scoped=true&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-efbed78a"]])

export default __exports__